import { ConnectorServiceEnum } from '@enum/connector-service.enum';
import { UnifiedApiEnum } from '@enum/unified-api.enum';

export enum ConnectorAuthTypeEnum {
  OAuth = 'oauth2',
  Basic = 'basic',
  None = 'none',
}

export enum ConnectorStatusEnum {
  Live = 'live',
}

export interface ConnectorScopeInterface {
  id: string;
  name: string;
  isEnabled: boolean;
}

export interface ConnectorInterface {
  id: string;
  serviceId: ConnectorServiceEnum;
  name: string;
  docUrl?: string;
  hasFTP: boolean;
  unifiedApi: UnifiedApiEnum;
  status: ConnectorStatusEnum;
  authType: ConnectorAuthTypeEnum;
  description: string;
  oauthScopes: ConnectorScopeInterface[];
  webhookScopes: ConnectorScopeInterface[];
  websiteUrl?: string;
  resources: { type: string; nativeAttributes: string[] }[];
}
